export const LIMIT_COVER_IMAGE = 10 * 1024 * 1024;

export const LIMIT_COLLECTION_COVER_IMAGE_SIZE_PIXEL = 608;

export const LIMIT_UPLOAD_IMAGE_FILE_ACCEPT = '.jpg, .jpeg, .png, .gif, .webp';
